import React from "react";
import PropTypes from "prop-types";
import Cell from "../lds/table/Cell";
import Icon from "../lds/Icon";

const FeedsIndexTableHeader = ({
  className = "",
  field,
  label,
  onSortClick,
  sortData,
  width,
}) => {
  const classNames = [];

  if (className) {
    classNames.push(className);
  }

  const fieldIsSorted = sortData.field === field;

  const iconStyles = {
    width: 16,
    height: 16,
    backgroundColor: "black",
    minWidth: 16,
    minHeight: 16,
  };
  let trailingSortAction = (
    <>
      {/* <div className="flex-grow-1" /> */}
      <Icon
        name={`chevron-${
          fieldIsSorted && sortData.asc ? "up" : "down"
        }-centered`}
        style={iconStyles}
      />
    </>
  );

  return (
    <Cell
      id={"feed-index-table-header-" + field}
      header
      onClick={() => onSortClick(field)}
      className={classNames.join(" ")}
      style={{ textWrap: "nowrap" }}
    >
      {label} {trailingSortAction}
    </Cell>
  );
};

FeedsIndexTableHeader.propTypes = {
  className: PropTypes.string,
  field: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onSortClick: PropTypes.func.isRequired,
  sortData: PropTypes.object.isRequired,
};

export default FeedsIndexTableHeader;
